module.exports = __webpack_public_path__ + "media/images/sp-about-head@3x-1a5543ab13a4eb2839b93e14832f790a.png";